import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const LandingView = () => import(/* webpackChunkName: "public-landing" */ '@/views/public/LandingView.vue');
const SharedView = () => import(/* webpackChunkName: "public-share" */ '@/views/public/SharedView.vue');
const UserLogin = () => import(/* webpackChunkName: "auth" */ '@/views/login/UserLogin.vue');
const RegisterView = () => import(/* webpackChunkName: "auth" */ '@/views/login/RegisterView.vue');
const CompanySelectView = () => import(/* webpackChunkName: "account" */ '@/views/base/CompanySelectView.vue');
const OnboardingView = () => import(/* webpackChunkName: "account" */ '@/views/base/OnboardingView.vue');
const AccountView = () => import(/* webpackChunkName: "account" */ '@/views/account/AccountView.vue');
const DashboardView = () => import(/* webpackChunkName: "recorder-dashboard" */ '@/views/recorder/DashboardView.vue');
const EventsView = () => import(/* webpackChunkName: "recorder-events" */ '@/views/recorder/EventsView.vue');
const EventDetailView = () => import(/* webpackChunkName: "recorder-event" */ '@/views/recorder/EventDetailView.vue');
const RecordingsView = () => import(/* webpackChunkName: "recorder-recordings" */ '@/views/recorder/RecordingsView.vue');
const SharesView = () => import(/* webpackChunkName: "recorder-shares" */ '@/views/recorder/SharesView.vue');

const appMeta = { requiresAuth: true, layout: 'app', permission: 'recorder.access', module: 'recorder' };

const routes = [
  { path: '/', name: 'landing', component: LandingView },
  { path: '/login', name: 'login', component: UserLogin, meta: { guestOnly: true } },
  { path: '/registrarse/:sellerToken?', name: 'register', component: RegisterView, props: true, meta: { guestOnly: true } },
  { path: '/compartir/:token', name: 'shared', component: SharedView },

  { path: '/app', name: 'recorder-dashboard', component: DashboardView, meta: appMeta },
  { path: '/app/eventos', name: 'recorder-events', component: EventsView, meta: appMeta },
  { path: '/app/eventos/:token', name: 'recorder-event', component: EventDetailView, meta: appMeta },
  { path: '/app/grabaciones', name: 'recorder-recordings', component: RecordingsView, meta: appMeta },
  { path: '/app/enlaces', name: 'recorder-shares', component: SharesView, meta: appMeta },

  { path: '/seleccionar-empresa', name: 'company-select', component: CompanySelectView, meta: { requiresAuth: true, layout: 'app' } },
  { path: '/configuracion-inicial', name: 'onboarding', component: OnboardingView, meta: { requiresAuth: true, layout: 'app' } },
  { path: '/cuenta', name: 'account', component: AccountView, meta: { requiresAuth: true, layout: 'app' } },
  { path: '/dashboard', redirect: '/app' },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const isLogged = Boolean(store.state.isLoggedIn && store.state.authToken);
  if (to.meta.requiresAuth && !isLogged) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }
  if (to.meta.guestOnly && isLogged) {
    return store.state.context?.next_route || '/app';
  }
  if (to.meta.requiresAuth && !store.state.context && to.name !== 'company-select' && to.name !== 'onboarding') {
    return { name: 'company-select' };
  }
  if (to.meta.permission && !store.getters.hasPermission(to.meta.permission)) {
    return { name: 'account' };
  }
  if (to.meta.module && !store.getters.hasModule(to.meta.module)) {
    return { name: 'account' };
  }
  return true;
});

export default router;
